import * as types from './actionTypes';

export function mediaChanged(payload) {
  return { type: types.MEDIA_CHANGED, payload };
}
